import { render, staticRenderFns } from "./OverviewStep.vue?vue&type=template&id=21dc474a"
import script from "./OverviewStep.vue?vue&type=script&lang=ts"
export * from "./OverviewStep.vue?vue&type=script&lang=ts"
import style0 from "./OverviewStep.vue?vue&type=style&index=0&id=21dc474a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports